import { render, staticRenderFns } from "./SaxxRadio.vue?vue&type=template&id=407b283c"
import script from "./SaxxRadio.vue?vue&type=script&lang=js"
export * from "./SaxxRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports